import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/common/Header';
import Sidebar from '../components/common/Sidebar';
import Footer from '../components/Footer';
import { ROUTE_PATHS } from '../routes/routePaths';

const PrivateLayout = ({ children }: { children: React.ReactNode }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const handleCloseSidebar = () => setShowSidebar(false);
  const handleShowSidebar = () => setShowSidebar(true);
  const location = useLocation();

  const isAdvanceSearch = location.pathname.includes('advanced-search');
  const isContentTileView = location.pathname === ROUTE_PATHS.CONTENT_TILE_VIEW_GRID;

  // Apply body overflow hidden for content-tile-view page (matching CFM)
  useEffect(() => {
    document.body.style.overflow = isContentTileView ? 'hidden' : '';

    // Cleanup on unmount
    return () => {
      if (isContentTileView) {
        document.body.style.overflow = '';
      }
    };
  }, [isContentTileView]);

  return (
    <>
      <Header onToggleSidebar={handleShowSidebar} isContentTileView={isContentTileView} />
      <Sidebar show={showSidebar} handleClose={handleCloseSidebar} />
      <div className={`ao_vh100 d-flex flex-column ${isAdvanceSearch ? "ao_rowBg" : ""}`}>{children}</div>
      {!isContentTileView && <Footer />}
    </>
  );
};

export default PrivateLayout;
